import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import {
  StyledSideBar,
  LogoContainer,
  UserSection,
  UserContent,
  Avatar,
  UserInfo,
  UserName,
  UserCompany,
  Links,
  Link,
  LogoutLink,
  ClientSection,
  ClientSectionHeader,
  Gradient,
  ClientList,
  Client,
  ClientName,
  SideCaretWrapper,
  ClientListItem,
  Feed,
  EmptyFeed
} from "./styles";

import {
  SideCaretIcon,
  TVAdExposureIcon,
  NoFeedsIcon,
  LogoIcon
} from "../../icons";
import { selectAllClients } from "../../selectors";
import { truncate } from "../../utils";

const MAX_CLIENT_NAME_LENGTH = 32;

export class SideBar extends Component {
  state = {
    openClientId: null
  };

  handleHomeClick = this.handleHomeClick.bind(this);
  handleAnalyticsClick = this.handleAnalyticsClick.bind(this);

  getBaseUrl() {
    const getUrl = window.location;
    let baseUrl = `${getUrl.protocol}//${getUrl.host}`;
    baseUrl = baseUrl.replace("3000", "8080");
    return baseUrl;
  }

  handleCaretClick(id) {
    if (this.state.openClientId === id) {
      this.setState({ openClientId: null });
    } else {
      this.setState({ openClientId: id });
    }
  }

  handleNameClick(clientId) {
    this.setState({ openClientId: clientId });
    this.props.history.push(`/clients/${clientId}`);
  }

  handleHomeClick() {
    this.setState({ openClientId: null });
    this.props.history.push("/");
  }

  handleAnalyticsClick() {
    this.setState({ openClientId: null });
    this.props.history.push("/analytics");
  }

  render() {
    const {
      clients,
      currentUser,
      pathname,
      history,
      selectFeedById
    } = this.props;
    const { openClientId } = this.state;
    return (
      <StyledSideBar>
        <LogoContainer onClick={this.handleHomeClick}>
          <LogoIcon />
        </LogoContainer>
        <UserSection>
          <UserContent>
            <Avatar src={currentUser.avatar} alt="User Profile" />
            <UserInfo>
              <UserName>{currentUser.displayName}</UserName>
              <UserCompany>{currentUser.company || "Samba TV"}</UserCompany>
            </UserInfo>
          </UserContent>
          {/* <SideCaretIcon /> */}
        </UserSection>
        <Links>
          <Link isActive={pathname === "/"} onClick={this.handleHomeClick}>
            Home
          </Link>
          <Link isActive={pathname === "/analytics"} onClick={this.handleAnalyticsClick}>
            Analytics
          </Link>
          <LogoutLink href={`${this.getBaseUrl()}/auth/logout`}>
            Logout
          </LogoutLink>
        </Links>
        <ClientSection>
          <ClientSectionHeader>
            CLIENTS
            <Gradient />
          </ClientSectionHeader>
          <ClientList data-cy="client-list">
            {clients.map(client => {
              let clientId = client.id;
              let clientName = client.name;
              let isClientPath = pathname.includes(`/clients/${clientId}`);
              let open = openClientId === clientId || isClientPath;
              return (
                <ClientListItem key={clientName}>
                  <Client isActive={isClientPath}>
                    <ClientName onClick={() => this.handleNameClick(clientId)}>
                      {truncate(clientName, MAX_CLIENT_NAME_LENGTH)}
                    </ClientName>
                    <SideCaretWrapper
                      open={open}
                      onClick={() => this.handleCaretClick(clientId)}
                    >
                      <SideCaretIcon />
                    </SideCaretWrapper>
                  </Client>
                  {client.feed_ids.map(feedId => {
                    let feed = selectFeedById(feedId);
                    let feedPath = `/clients/${clientId}/feeds/${feedId}`;

                    return (
                      <Feed
                        key={feedId}
                        open={open}
                        onClick={() => history.push(feedPath)}
                        isActive={pathname === feedPath}
                      >
                        <TVAdExposureIcon />
                        {feed && feed.name}
                      </Feed>
                    );
                  })}
                  {client.feed_ids.length === 0 && (
                    <EmptyFeed open={open}>
                      <NoFeedsIcon />
                      No feeds
                    </EmptyFeed>
                  )}
                </ClientListItem>
              );
            })}
          </ClientList>
        </ClientSection>
      </StyledSideBar>
    );
  }
}

SideBar.propTypes = {
  currentUser: PropTypes.shape({
    displayName: PropTypes.string,
    avatar: PropTypes.string,
    company: PropTypes.string
  }).isRequired,
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      client: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.string,
      start: PropTypes.string,
      end: PropTypes.string,
      impressions: PropTypes.number,
      devices: PropTypes.number,
      networks: PropTypes.string,
      airings: PropTypes.number,
      brands: PropTypes.string,
      status: PropTypes.string
    })
  ),
  pathname: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  selectFeedById: PropTypes.func
};

export default withRouter(
  connect((store, props) => ({
    pathname: props.location.pathname,
    currentUser: store.currentUser,
    clients: selectAllClients(store).sort((a, b) => {
      const name1 = a.name.toLowerCase();
      const name2 = b.name.toLowerCase();
      if (name1 < name2) return -1;
      if (name1 > name2) return 1;
      return 0;
    }),
    selectFeedById: id => store.entities.feeds.byId[id]
  }))(SideBar)
);
